<template lang="html">
  <div>
    <v-container justify-center wrap fluid class="contact-container">
      <v-layout justify-center wrap>
        <v-flex xs12 sm8 md8 lg6>
          <h1 class="contact-title">Contact Us</h1>

          <v-flex mt-4>
            <p class="body-text">We appreciate your interest in Blitzoo.</p>
          </v-flex>

          <v-flex mt-4 align-center justify-center row class="contact-email">
            <!-- <v-icon x-large class="orange--text text--lighten-2">email</v-icon> -->
            <img src="../assets/Icon_Mail.svg" height="26px" />
            <h3 class="contact-subtitle">Careers:</h3>
            <a href="mailto:careers@blitzoo.com" target="_top" class="email-style" style="margin-left: 1rem;">careers@blitzoo.com</a>
          </v-flex>

          <v-flex mt-4 align-center justify-center row class="contact-email">
            <!-- <v-icon x-large class="orange--text text--lighten-2">email</v-icon> -->
            <img src="../assets/Icon_Mail.svg" height="26px" />
            <h3 class="contact-subtitle">Business Inquiries:</h3>
            <a href="mailto:contact@blitzoo.com" target="_top" class="email-style" style="margin-left: 1rem;">contact@blitzoo.com</a>
          </v-flex>

          <v-flex mt-4 align-center justify-center row class="contact-email">
            <img src="../assets/Icon_Mail.svg" height="26px" />
            <h3 class="contact-subtitle">Casino App Support Inquiries:</h3>
            <a href="mailto:support@blitzoo.com" target="_top" class="email-style" style="margin-left: 1rem;">support@blitzoo.com</a>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'Contact'
}
</script>

<style lang="scss" scoped>
// #contact-container {
//   display: grid;
//   place-self: center;
// }
//
// #content {
//   color: white;
//   text-align: left;
//   width: 55vw;
//   height: 50vh;
// }
.contact-container {
  background-image: url('../assets/Header_Contact.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.contact-title {
  font-family: 'open-sans-extrabold', serif;
  font-weight: 700;
  font-size: 45px;
  color: #ffffff;
  letter-spacing: -1px;
}

.contact-subtitle {
  font-family: 'open-sans-extrabold', serif;
  font-style: normal;
  font-weight: 800;
  font-size: 18px;
  color: #ffffff;
  margin-left: 0.5rem;
}

.contact-email {
  display: flex;
}

.body-text {
  font-size: 18px;
  color: #ffffff;
}

.email-style {
  font-family: 'open-sans-semibold', serif;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #ffffff;
  text-decoration: none;
}

.description-body {
  padding-top: 0;
}

.contact-text-container {
  display: grid;
  justify-content: center;
}

#outer-container {
  display: grid;
  justify-content: center;
}

#wrap-container {
  // color: white;
  text-align: left;
  width: 70vw;
}

#title {
  margin-bottom: 2rem;
}

#content-grid {
  display: grid;
  // grid-template-columns: 1fr 1fr 1fr;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(3, 1fr);
}
</style>
